import { NavLink } from "../../../../../../types/drawer/NavItem";
import Icon, { icons } from "../icon/Icon";
import { Link, useLocation } from "react-router-dom";

interface SubMenuProps {
  isOpen: boolean;
  isDropdownOpen: boolean;
  link: NavLink;
  setOpenDropdown: (value: string | null) => void;
}

export default function SubMenu({
  isOpen,
  isDropdownOpen,
  link,
  setOpenDropdown,
}: SubMenuProps) {
  const location = useLocation();

  return (
    <div>
      {isDropdownOpen && (
        <div
          className={`my-[8px] ${
            isOpen &&
            "border-l-[1px] ml-[18px] !my-[20px] border-[#6B96D633] pl-[18px]"
          }`}
        >
          {link?.children?.map((category, catIndex) => (
            <div key={catIndex} className="mt-2">
              <p
                className={`text-[10px] ${
                  !isOpen &&
                  "flex items-center group py-2 !mt-[12px] px-3 text-[10px] font-[500] transition-all duration-300 text-[#dae8fd] hover:bg-[#0193f8] hover:text-[#042849] justify-center h-[45px] w-[45px] mx-auto rounded-[10px]"
                } mb-[10px] mt-[10px] uppercase text-[#6B96D6]`}
              >
                {!isOpen && (
                  <Icon
                    isOpen={isOpen}
                    category={true}
                    isActive={false}
                    name={category.icon as keyof typeof icons}
                  />
                )}
                {isOpen && <span>{category.category}</span>}
              </p>

              {category.links.map((sublink, subIndex) => {
                const isSubLinkActive = location.pathname === sublink.href;

                return (
                  <Link
                    to={sublink.href}
                    key={subIndex}
                    onClick={() => {
                      setOpenDropdown(null);
                    }}
                    className={`block py-2 px-3 ${
                      !isOpen &&
                      "flex items-center group my-[5px] h-[40px] px-3 text-[16px] transition-all duration-300 text-[#dae8fd] hover:bg-[#0193f8] hover:text-[#042849] justify-center w-[40px] mx-auto rounded-[10px]"
                    } text-[14px] ${
                      isSubLinkActive
                        ? `text-[#05050F] bg-[#6B96D6] !py-0 h-[32px] ${
                            !isOpen && "!h-[40px]"
                          } items-center flex rounded-[12px] !font-[400] px-[8px] ${
                            !isOpen && "bg-[#0193f8]"
                          } font-semibold`
                        : "text-[#0193F8] hover:text-[#fff]"
                    }`}
                  >
                    {!isOpen && (
                      <Icon
                        isOpen={isOpen}
                        isActive={isSubLinkActive}
                        name={sublink.icon as keyof typeof icons}
                      />
                    )}
                    {isOpen && <span>{sublink.text}</span>}
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
